import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SiteDto } from '@dto';

@Component({
  imports: [TranslatePipe],

  selector: 'monitor-ui-site-financial',
  styleUrls: ['./site-financial.component.scss'],
  templateUrl: './site-financial.component.html',
})
export class SiteFinancialComponent implements OnInit {
  @Input() site: SiteDto;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.site = this.route.snapshot.data['data'];
  }
}
